<template>
  <div id="contents">
    <div class="recruit_movie" v-if="movie_post" >
      <div class="recruit_movie_main">
        <div class="title_area">
          <p :class="[movie_post.title_layout_type === 1 ? 'title_layout_1' : 'title_layout_2']" v-for="title in movie_post.title" :key="title.id">{{ title.text }}</p>
        </div>
        <div @click="close" class="close_icon">
          <img src="../assets/img/common/recruit_2021/close_icon.svg" alt=""/>
        </div>
        <p class="caption" :class="[movie_post.title_layout_type === 1 ? 'title_layout_1_caption' : 'title_layout_2_caption']" v-html="movie_post.caption"></p>
        <template v-if="movie_post.producer_layout_type === 1">
          <video autoplay controls muted class="video_long_type" >
            <source :src="[ this.video_base_url + movie_post.movie]">
          </video>
          <div class="producer_layout1_title">
            <p>制作者コメント</p>
          </div>
          <div class="producer_layout1" v-for="producer in movie_post.producer" :key="producer.id">
            <div class="thumbnail">
              <img :src="producer.image" alt="">
            </div>
            <div class="text_area">
              <p class="info" v-for="info in producer.info" :key="info.id">{{ info.text }}</p>
              <h4>{{ producer.name }}</h4><p class="name_en">{{producer.name_en}}</p>
              <img src="../assets/img/common/recruit_2021/recruit_movie_pink_line.svg" alt="">
              <p class="text" v-html="producer.text"></p>
            </div>
          </div>
        </template>
        <template v-if="movie_post.producer_layout_type === 2">
           <video autoplay controls muted class="video_wide_type" >
            <source :src="[ this.video_base_url + movie_post.movie]">
          </video>
          <div class="producer_layout2_title">
            <p>制作者コメント</p>
          </div>
          <div class="producer_layout2" v-for="producer in movie_post.producer" :key="producer.id">
            <div class="thumbnail">
              <img :src="producer.image" alt="">
            </div>
            <div class="text_area">
              <p class="info">{{ producer.info }}</p>
              <h4>{{ producer.name }}</h4><p class="name_en">{{producer.name_en}}</p>
              <img src="../assets/img/common/recruit_2021/pink_line.svg" alt="">
              <p class="text" v-html="producer.text"></p>
            </div>
          </div>
        </template>
      </div>
      <div class="relation_movie_list">
        <div class="title">
          <h4>関連ムービー</h4>
        </div>
        <ul>
          <li v-for="relation_movie in movie_post.relation_movie" :key="relation_movie.id" @click="reload_model(relation_movie.movie_id, 'movie')">
            <div class="thumbnail">
              <img :src="relation_movie.thumbnail" alt="">
            </div>
            <div v-if="relation_movie.title_layout_type == 1" >
              <p>{{ relation_movie.title }}</p>
            </div>
            <div v-else-if="relation_movie.title_layout_type == 2">
              <p v-html="relation_movie.title"></p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
import movie_post_list from './js/recruit_movie.json'
export default {
  name: 'recruit_movie',
  data() {
    return {
      video_base_url: '../static/recruit_2021',
      movie_post_list: movie_post_list,
      movie_post: null,
      request_id: null,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  props: [
    'post_type'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
    this.fetch_movie_post(this.$route.params.id)
    if( window.location.protocol + '//' + window.location.host == "https://www.tv-asahipro.co.jp" ){
      this.video_base_url = "https://www.tv-asahipro.co.jp/recruit2021"
    } else if ( window.location.protocol + '//' + window.location.host == "http://vivia.stg-malk.com" ){
      this.video_base_url = "http://vivia.stg-malk.com/recruit2021"
    } else {
    }
  },
  methods: {
    fetch_movie_post(request_id){
      this.movie_post = this.movie_post_list[request_id]
    },
    reload_model(post_id, layout) {
      var post = this.movie_post_list.find(post => post.id == post_id);
      if (post != null){
        this.$emit('reload_model', post_id, layout);
      }
    },
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  .recruit_movie
    &_main
      width: 1000px
      margin: 0 auto
      margin-top: 161px
      padding-bottom: 93px
      background-color: #fff
      position: relative
      .title_area
        position: absolute
        top: -49px
        left: 55px
      .title_layout_1
        @include recruit_font(41px, 41px, .176em)
        color: #fff
        background: #3785E0
        padding: 17px 0px 15px 14px
        display: table
        &:not(:first-child)
          @include recruit_font(41px, 41px, .156em)
          padding: 11px 9px 19px 14px
      .title_layout_2
        @include recruit_font(41px, 78px, 7px)
        color: #fff
        background: #02ACC3
        padding: 0 0 0 14px
        display: table
        &:not(:first-child)
          @include recruit_font(41px, 41px, 7px)
          padding: 0 1vw 1.4vw 1vw

      .close_icon
        position: absolute
        right: 0px
        top: -65px
        img
          width: 40px
          height: 40px
      .caption
        @include recruit_font(14px, 28px, 3px)
        display: inline-block
      .video_long_type
        margin: 0 342px
        width: 316px
        height: 560px
      .video_wide_type
        margin: 0 95px
        width: 810px
        height: 458px
      .title_layout_1_caption
        margin: 124px 55px 67px 55px
      .title_layout_2_caption
        margin: 75px 50px 99px 50px
      .producer
        &_layout1
          width: 890px
          margin: 0 auto
          display: flex
          &_title
            height: 51px
            width: 890px
            margin: 83px auto 49px
            background-color: #3785E0
            text-align: center
            p
              @include recruit_font(23px, 51px, 4px)
              color: #fff
          &:not(:first-child)
            margin-top: 48px
          .thumbnail
            width: 140px
            height: 140px
            img
              width: 140px
              height: 140px
          .text_area
            margin-left: 32px
            .info
              @include recruit_font(12px, 12px, 0.126em)
              margin-bottom: 4px
              color: #FF7689
            h4
              @include recruit_font(22px, 22px, .206em)
              color: #FF7689
              margin-top: 13px
              float: left
            .name_en
              @include recruit_font(16px, 22px, .066em)
              color: #FF7689
              margin: 13px 0 0 10px
              display: inline-block
            img
              width: 718px
              margin-top: 14px
              display: block
            .text
              margin-top: 9px
              @include recruit_font(12px, 23px, .206em)
        &_layout2
          width: 890px
          margin: 0 auto
          display: flex
          &_title
            height: 51px
            width: 890px
            margin: 129px auto 62px
            background-color: #02ACC3
            text-align: center
            p
              @include recruit_font(23px, 51px, 4px)
              color: #fff
          .thumbnail
            width: 140px
            height: 140px
            img
              width: 140px
              height: 140px
          .text_area
            margin-left: 32px
            width: 718px
            overflow: hidden
            .info
              @include recruit_font(12px, 12px, 1px)
              margin-bottom: 10px
              color: #FF7689
            h4
              @include recruit_font(22px, 28px, 4px)
              color: #FF7689
              float: left
            .name_en
              @include recruit_font(16px, 28px, 1px)
              color: #FF7689
              margin-left: 10px
              display: inline-block
            img
              width: 710px
              margin-top: 14px
              display: block
            .text
              @include recruit_font(12px, 23px, 2px)
              padding-top: 9px
    .relation_movie_list
      width: 1000px
      margin: 0 auto
      margin-top: 73px
      .title
        width: 230px
        height: 48px
        background-color: #fff
        h4
          @include recruit_font(28px, 41px, 4px)
          color: #FF7689
          margin: 0 24px 0 13px
      ul
        margin-top: 52px
        margin-bottom: 122px
        display: flex
        flex-wrap: wrap
        justify-content: space-between
        &::after
          content: ""
          display: block
          width: 318px
        li
          width: 318px
          margin-bottom: 58px
          cursor: pointer
          .thumbnail
            width: 318px
            height: 180px
            background-color: #D8D8D8
            position: relative
            overflow: hidden
            img
              width: 102%
              position: absolute
              left: 50%
              top: 50%
              transform: translate(-50%, -50%)
              transition: .3s all
            &:hover
              img
                transform: translate(-50%, -50%) scale(1.1)
          p
            @include recruit_font(13px, 19px, .176em)
            color: #fff
            margin-top: 9px
</style>



// WEBPACK FOOTER //
// src/components/recruit_movie.vue